<template>
    <div :style="containerStyle">
        <video v-if="videoUrl" style="width: 100%; height: auto;" class="rounded-lg"
               preload="auto" muted autoplay loop playsinline>
            <source :src="videoUrl" type="video/mp4">
        </video>

        <div v-else-if="embedHtml && isYouTubeEmbed">
            Youtube video
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoRenderer',
    props: ['component', 'videoUrl', 'embedHtml'],
    computed: {
        isYouTubeEmbed() {
            return this.embedHtml && this.embedHtml.indexOf('iframe') > -1 && this.embedHtml.indexOf('src="https://www.youtube.com') > -1
        },
        videoClasses() {
            return `w-100 ${this.marginClasses} ${this.paddingClasses}`.trim()
        },
        containerStyle() {
            if(this.videoUrl) {
                return ''
            }

            return 'width: 300px; height: 100px'
        },
        marginClasses() {
            if (!this.component.margin) {
                return ''
            }

            return webase.utils.ui.getMarginClass(this.component.margin)
        },
        paddingClasses() {
            if (!this.component.padding) {
                return ''
            }

            return webase.utils.ui.getPaddingClass(this.component.padding)
        },
        // borderClass() {
        //     if(!this.component.border || this.component.border === 'none') {
        //         return ''
        //     }
        //
        //     if(this.component.border === 'rounded') {
        //         return 'rounded-lg'
        //     }
        //
        //     return `rounded-${this.component.border}`
        // },
        // imageStyles() {
        //     return `${this.sizeStyles} ${this.objectFitStyle}`
        // },
        // sizeStyles () {
        //     if(!this.component.width && !this.component.height) {
        //         return ''
        //     }
        //     if(!this.component.width) {
        //         return `height: ${this.component.height}px !important;`
        //     }
        //     if(!this.component.height) {
        //         return `width: ${this.component.width}px !important;`
        //     }
        //
        //     return `width: ${this.component.width}px !important; height: ${this.component.height}px !important;`
        // },
        // objectFitStyle() {
        //     if(!this.component.objectFit || this.component.objectFit === 'none') {
        //         return ''
        //     }
        //
        //     return `object-fit: ${this.component.objectFit};`
        // }
    }
}
</script>

<style>

</style>